/* unplugin-vue-components disabled */import script from "./ChooseAdditional.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseAdditional.vue?vue&type=script&setup=true&lang=js"

import "./ChooseAdditional.vue?vue&type=style&index=0&id=1ad61079&lang=scss"

const __exports__ = script;

export default __exports__